import React from 'react';
import { Film, Image, File, FileText, AlignLeft, Link, Headphones  } from 'react-feather';
import { ContentType, ContextLocation, FoundIn, Match, SearchResult } from './interfaces/Search';
import LoadingSpinner from './LoadingSpinner/LoadingSpinner';
import { getRelativeDate } from './utility';


const Result =({result, isDraft}: {result: SearchResult, isDraft?:boolean}) => {

    function getFallbackImagePath(mediaType: ContentType | string) {
        if (['video', 'audio', 'text', 'list', 'contact', 'existing', 'html', 'page', 'rss', 'text', 'file', 'image', 'combinedFeed'].includes(mediaType)) {
            return `/Content/img/icons/types/${mediaType}_icon.svg`
        }
        else if(mediaType === 'web') {
            return `/Content/img/icons/types/html_icon.svg`
        }
        return `/Content/img/icons/types/page_icon.svg`
    }

    const ImagePlaceHolder = ({mediaType}: {mediaType: string}) => {
        return <img style={{height: '95%'}} src={getFallbackImagePath(mediaType)} />
    }

    const MediaIcon = ({mediaType}:{mediaType: ContentType | string}) => {
        switch(mediaType) {
            case 'video':
                return <Film size={10} color={'#9EA8BA'} className='search-media-icon' />
            case 'image':
                 return <Image size={10} color={'#9EA8BA'} className='search-media-icon' />
            case 'file':
                return <File size={10} color={'#9EA8BA'} className='search-media-icon' />
            case 'page':
            case 'title':
                return <FileText size={10} color={'#9EA8BA'} className='search-media-icon' />
            case 'text':
                return <AlignLeft size={10} color={'#9EA8BA'} className='search-media-icon' />
            case 'link':
                return <Link size={10} color={'#9EA8BA'} className='search-media-icon' />
            case 'audio':
                return <Headphones size={10} color={'#9EA8BA'} className='search-media-icon' />
            default:
                return <></>
        } 
    }

    function addElipsesToTextMatch(contextLocation: ContextLocation, matchText: string): string {
        return (
            `${[ContextLocation.End, ContextLocation.Middle].includes(contextLocation) ? '...' : ''}` +
            `${matchText}` +
            `${[ContextLocation.Start, ContextLocation.Middle].includes(contextLocation) ? '...' :''}`
        )
    }
    
    const GetMatchType = ({match}:{match:Match}) => {
        if (!match) {
            return <><MediaIcon mediaType='page'/>1 Result</>
        }

        switch(match.matchType) {
            case 'media':
                return <><MediaIcon mediaType={match.mediaKind} />{match.caption ? match.caption : match.filename}</>
            case 'title':
                return <><MediaIcon mediaType={'title'} />Title Match</>
            case 'multiple':
                return <><MediaIcon mediaType='page'/>{match.count} Results</>
            case 'text':
                return  <><MediaIcon mediaType='text'/><span className='bold'></span>{addElipsesToTextMatch(match.contextLocation, match.context)}</>
            default:
                return <><MediaIcon mediaType='page'/>1 Result</>
        }

    }

    const FoundInLocation = ({foundIn}:{foundIn:FoundIn}) => {
        if(foundIn.foundInType === 'single') {
            return <>{`Found in ${foundIn.locationPath.join('/')}`}</>
        }
        
        return <>{`${foundIn.count} Results`}</>
    }

    function GetDate({result}:{result:SearchResult}){
        if(result.publishDate) {
            return <p className='information-item'>Published {getRelativeDate(new Date(result.publishDate))}</p>
        }
        else if(result.modifiedDate) {
            return <p className='information-item'>Last Edited {getRelativeDate(new Date(result.modifiedDate))}</p>
        }
        
        return <></>
    }

    

    return (<li className='search-result lp-search-result'>
            <a className='search-link lp-search-link' href={`${window.location.origin}/${result.contentUrl}`}>
            {result.featuredImage 
                ? <div
                    className='lp-featured-image'
                    aria-label={`${result.title} featured image`}
                    style={{backgroundImage: `url(${result.featuredImage.url}?width=160), url(${getFallbackImagePath(result.contentType)}) `}}
                    onError={(e) => {
                        (e.target as HTMLImageElement).classList.add('lp-fallback');

                    }}
                />
                : 
                <div className='lp-featured-image lp-placeholder'>
                    <ImagePlaceHolder mediaType={result.contentType} />
                </div>
                }
                <div className='search-result-information-container'>
                    <h2 className='result-title'>
                        <span className='title-text'>{result.title}</span>
                        {isDraft && <span className='language-alert'>Draft</span>}
                    </h2>
                    {result.match && <h3 className='match-type'><GetMatchType match={result.match}/></h3>}
                    {result.foundIn && <h3 className='information-item'><span className='title-text'><FoundInLocation foundIn={result.foundIn}/></span></h3>}
                    <GetDate result={result} />
                </div>
                
            </a>
        </li>
    )
}


const LandingPageSearchResults = ({isLoading=false, results, isDraft}:{isLoading?: boolean, results: SearchResult[], isDraft?: boolean}) => {
    return (
        <section className='search-results-container lp'>
            {(!isLoading && !results?.length) &&
                <p className='no-results'>No results found</p>
            }
            {(isLoading && !results?.length)
                ? <div style={{paddingTop: '10px', paddingBottom: '10px'}}><LoadingSpinner size={22}/></div>
                : <ul className='search-results-list lp'>
                    {results.map((r, idx) => <Result key={`${r.title}-${r.publishDate}-${idx}`} result={r} isDraft={isDraft}/>)} 
                </ul>
            }
        </section>
    )
}

export default LandingPageSearchResults;